import { SaleBadgeProps } from '../../types';
import babaBadge from 'assets/Baba/sale-badge.png';
import { StyledBabaSaleBadge, StyledBabaSaleBadgeNumber } from './style';
import { generateSalePercentageBasedOnType } from 'utils/index';

export const BabaSaleBadge = ({
  salePercentage,
  salePercentageDisplayType,
  isPromotion = false,
}: SaleBadgeProps & { isPromotion?: boolean }) => {
  return (
    <StyledBabaSaleBadge badgeOutline={isPromotion}>
      <img src={babaBadge} alt="sale-badge" />
      <StyledBabaSaleBadgeNumber className="badge-sale-number">
        <div>
          {generateSalePercentageBasedOnType(
            salePercentage,
            salePercentageDisplayType,
          )}
        </div>
        <div>More</div>
      </StyledBabaSaleBadgeNumber>
    </StyledBabaSaleBadge>
  );
};
